export const generateEmailWarningMessage = (emailAddress: string): string => {
  return `Removing this email subscription to ${emailAddress} will remove any associated documents in your Feed that have not already been moved to your Library.`;
};

export const messageCopy = {
  removeFeedWarningText:
    'Removing this RSS subscription will remove any associated documents in your Feed that have not already been moved to your Library.',
};
